"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _Add = _interopRequireDefault(require("@insided/shared/icons/Add"));

var AddTopicAnchor = function AddTopicAnchor(_ref) {
  var title = _ref.title,
      newTopicURL = _ref.newTopicURL;
  return (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(newTopicURL),
    "data-track": JSON.stringify({
      trigger: 'navigation',
      type: 'Topic Initiated'
    }),
    "data-ga-track": JSON.stringify({
      eventCategory: 'Homepage',
      eventAction: 'Create topic clicked',
      eventLabel: {
        Position: 'Navigation'
      }
    }),
    className: (0, _classnames.default)('menu-create-topic', 'qa-menu-create-topic', 'btn', 'btn--cta'),
    role: "button",
    title: title
  }, (0, _preact.h)("span", {
    "aria-hidden": "true",
    className: "header-navigation-button-icon"
  }, (0, _preact.h)(_Add.default, {
    width: 16,
    height: 16,
    fill: "currentColor"
  })), (0, _preact.h)("span", null, title));
};

var _default = AddTopicAnchor;
exports.default = _default;